import React, { useState, useMemo, useEffect } from "react";
import useDidMountEffect from "../../../customHooks/useDidMountEffect";
import { useTranslation } from "react-i18next";
import FilterbarChips from "../../FilterbarChips/FilterbarChips";
import editIcon from "../../../assets/images/edit-icon.png";
import editIconGreen from "../../../assets/images/edit-green.png";
import SalaryData from "../../../entities/SalaryData";
import RenderPensionDetails from "./RenderPensionDetails/RenderPensionDetails";
import { filterSalaryByDate } from "../../../utils/helpers/filterByDate";
import DetailsNotFound from "../../DetailsNotFound/DetailsNotFound";
import { useSelector } from "react-redux";
import DashboardRestOptionProps from "./DashboardRestOptionProps";
import { numberWithCommas } from "../../../utils/helpers/numberConverter";
import "./DashboardRestOption.scss";

const DashboardRestOption = (props: DashboardRestOptionProps) => {
  
const { userFunds, isAmit, isPensioner, userId ,pensionTypeDesc , haveYearlyReportsred , token,is101ButtonAllowed,pensionTypeDescCounter   } = useSelector(
  (state: any) => state.UserReducer
);
  const { t, i18n } = useTranslation("common");

  /* itay turgeman
   * create dynamic function to add all years from current year until current year and descriment 6 years
   * function return new string array with all options
   */

  const createYearsData = (): string[] => {
    const labelsArr = [t("DashboardRestOption.firstChipValue")];
    for (
      let i = new Date().getFullYear();
      i >= new Date().getFullYear() - 6;
      i--
    ) {
      labelsArr.push(i.toString());
    }
    labelsArr.push(t("DashboardRestOption.lastChipValue"));
    return labelsArr;
  };

  const labels: string[] = createYearsData();

  const { firstName, lastName, salaryDataRedux } = useSelector(
    (state: any) => state.UserReducer
  );
  const [currentActive, setCurrentActive] = useState(labels[0]);
  const [lastSuccessfulYear, setLastYear] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [iconEdit, setIconEdit] = useState(editIcon);
  const isActive = (label: string) => currentActive === label;

  useEffect(() => {
    if (salaryDataRedux && salaryDataRedux[0]) {
      setBankNumber(salaryDataRedux[0]?.bankAcountno.trim())
    }
  }, [salaryDataRedux])

  useDidMountEffect(() => {
    // console.log("frfrf");

    setCurrentActive(labels[0]);
  }, [i18n.language]);

  const filterByLatest12Months = () => {
    const endDate: Date | string = new Date().toLocaleDateString();
    let startDate: Date | string = new Date();
    startDate.setMonth(startDate.getMonth() - 12);
    startDate = startDate.toLocaleDateString();
    return filterSalaryByDate(props.userSalaryData, startDate, endDate);
  };

  const filterSalaryData = () => {
    if (currentActive === labels[0]) {
      // Case when year label value is last 12 months ..
      return filterByLatest12Months();
    } else {
      // Case when year label value is year value from labels ..
      return props.userSalaryData.filter(
        (salary: SalaryData) =>
          salary.salaryDate.split("-")[0] === currentActive
      );
    }
  };

  const filteredSalaryData = useMemo(() => {   
    if (props.userSalaryData && props?.userSalaryData.length) {
      return filterSalaryData();
    }
    return [];
    // eslint-disable-next-line
  }, [props?.userSalaryData, currentActive]);

  useEffect(() => {
    if (
      filteredSalaryData &&
      filteredSalaryData.length &&
      currentActive !== labels[labels.length - 1]
    ) {
      setLastYear(currentActive);
    }
    // eslint-disable-next-line
  }, [filteredSalaryData, filteredSalaryData?.length]);

  return (
    <>
      <div
        className="dashboard-funds-details"
        style={{ justifyContent: "space-between" }}
      >
        <div className="dashboard-rest-item">
          <div className="dashboard-rest-head-text">
            <h2 className="dashboard-fund-item-title">
              {t("Dashboard.lastKitzva")}
            </h2>
          </div>
          <div className="fund-item-value-wrapper">
            <span className="dashboard-shekel">₪</span>
            <span className="dashboard-fund-item-value">
              {numberWithCommas(
                Math.floor(props?.lastSalaryData?.salaryNeto)
              ) || 0}
            </span>
          </div>
          <div className="dashboard-rest-item-separator"></div>
          <div className="dashboard-rest-bottom-text desktop-flex">
            <div className="rest-bottom-text-wrapper">
              <span className="bottom-text-wrapper-label">
                {t("Dashboard.deductions")}
              </span>
              <div className="d-flex align-items-center">
                <span className="bottom-text-wrapper-value">
                  {props?.lastSalaryData?.totalSalaryDebit
                    ? props?.lastSalaryData?.totalSalaryDebit < 0
                      ? numberWithCommas(
                        Math.floor(props?.lastSalaryData?.totalSalaryDebit) *
                        -1
                      )
                      : numberWithCommas(
                        Math.floor(props?.lastSalaryData?.totalSalaryDebit)
                      )
                    : 0}
                </span>
                <span className="bottom-text-wrapper-shekel">₪</span>
              </div>
            </div>
            <div className="rest-bottom-text-separator"></div>
            <div
              className="rest-bottom-text-wrapper"
              style={{ marginRight: 0 }}
            >
              <span className="bottom-text-wrapper-label">
                {t("Dashboard.broto")}
              </span>
              <div className="d-flex align-items-center">
                <span className="bottom-text-wrapper-value">
                  {numberWithCommas(
                    Math.floor(props?.lastSalaryData?.totalSalaryBrutto)
                  ) || 0}
                </span>
                <span className="bottom-text-wrapper-shekel">₪</span>
              </div>
            </div>
          </div>
          <div className="dashboard-rest-bottom-text mobile-flex">
            <div className="rest-bottom-text-wrapper">
              <div className="bottom-text-wrapper-label mobile-text">
                {t("Dashboard.deductions")}
              </div>
              <span className="bottom-text-wrapper-shekel">₪</span>
              <span className="bottom-text-wrapper-value">
                {props?.lastSalaryData?.totalSalaryDebit
                  ? props?.lastSalaryData?.totalSalaryDebit < 0
                    ? numberWithCommas(
                      Math.floor(props?.lastSalaryData?.totalSalaryDebit) * -1
                    )
                    : numberWithCommas(
                      Math.floor(props?.lastSalaryData?.totalSalaryDebit)
                    )
                  : 0}
              </span>
            </div>
            <div className="rest-bottom-text-separator"></div>
            <div
              className="rest-bottom-text-wrapper"
              style={{ marginRight: 0 }}
            >
              <div className="bottom-text-wrapper-label mobile-text">
                {t("Dashboard.broto")}
              </div>
              <span className="bottom-text-wrapper-shekel">₪</span>
              <span className="bottom-text-wrapper-value">
                {numberWithCommas(
                  Math.floor(props?.lastSalaryData?.totalSalaryBrutto)
                ) || 0}
              </span>
            </div>
          </div>
        </div>
        <div className="dashboard-rest-bank-details">
          <div className="dashboard-fund-item-text">
            <h2 className="dashboard-fund-item-title">
              {t("Dashboard.bankDetails")}
            </h2>
            {/* <img
              src={iconEdit}
              onMouseEnter={() => {
                setIconEdit(editIconGreen);
              }}
              onMouseLeave={() => {
                setIconEdit(editIcon);
              }}
              alt="help"
            /> */}
          </div>
          <div className="rest-bank-details-wrapper">
            <span className="rest-bank-text-bold">{`${firstName} ${lastName}`}</span>
            <span className="rest-bank-text-bold">
              {t("personalDetails.bankName")}{" "}{" "}
              <span style={{ fontWeight: "normal" }}>
                {props?.lastSalaryData?.bankDescription}
              </span>
            </span>
            <span className="rest-bank-text-bold">
              {t("personalDetails.bankCode")}{" "}
              <span style={{ fontWeight: "normal" }}>
                {props?.lastSalaryData?.branchCode}
              </span>
            </span>
            <span className="rest-bank-text-bold">
              {t("Dashboard.bankNumber")}{" "}
              <span
                style={{ fontWeight: "normal" }}
              >
                {bankNumber}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="dashboard-rest-pension-details">
        <h2 className="rest-pension-details-title rest-pension-details-label">
            {t("Dashboard.tlushiPension")}
        </h2>
        <div
          className="filter-bar"
          style={{ borderBottom: "1px solid #E7EBF1" }}
          role="region"
          aria-label="סינון על פי חודשים/שנים"
        >
          <FilterbarChips
            labelsArray={labels}
            setCurrentActive={setCurrentActive}
            currentActive={currentActive}
            isActive={isActive}
            spacing={0}
            fromDashboard={true}
          />
        </div>
        <h3 className="visually-hidden" tabIndex={0}>{`סינון-${currentActive}`}</h3> 
        <div
          role="table"
          aria-label="טבלת תלושי פנסיה"
          aria-describedby="טבלת תלושי פנסיה">
          <div role="rowgroup">
            <div
              className="rest-pension-details-headers"
              style={{ display: `${!filteredSalaryData?.length ? "none" : ""}` }}
              role="row"
            >
              <span className="pension-details-header" role="columnheader" >
                {t("Dashboard.monthSalary")}
              </span>
              <span className="pension-details-header" role="columnheader" >
                {t("Dashboard.neto")}
              </span>
            </div>
          </div>
          {!(filteredSalaryData && filteredSalaryData.length) ? (
            <DetailsNotFound
              yearsOnly={true}
              lastSuccessfulYear={lastSuccessfulYear}
              setCurrentActive={setCurrentActive}
              alertMsg={true}
            />
          ) : (            
            <div role="rowgroup">
            {filteredSalaryData?.map((salary: SalaryData, key:number) => (       
              key % pensionTypeDescCounter == 0 ? <RenderPensionDetails key={salary.salaryDate} salary={salary} /> : null              
            )
            )}
          </div>    
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardRestOption;
